import { WeatherLightningIcon } from './WeatherLightningIcon';

/**
 * author: Austin Andrews
 * id 6AF7BD8A-088F-4B07-806D-7456EB382D76
 * name weather-lightning
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weather-lightning.svg
 * tags
 * - Weather 
 * - Agriculture 
 */
export const WeatherStormIcon = WeatherLightningIcon;
export default WeatherStormIcon